"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceRequestStatus = exports.ServiceType = void 0;
var ServiceType;
(function (ServiceType) {
    ServiceType["HVAC_FILTER_SERVICE"] = "HVAC_FILTER_SERVICE";
    ServiceType["HVAC_FILTER_ORDER"] = "HVAC_FILTER_ORDER";
    ServiceType["LEAK"] = "LEAK";
    ServiceType["LEAK_DETECTOR_SERVICE"] = "LEAK_DETECTOR_SERVICE";
    ServiceType["SENSOR_ALERT"] = "SENSOR_ALERT";
    ServiceType["HIGH_CURRENT"] = "HIGH_CURRENT";
    ServiceType["LOW_CURRENT"] = "LOW_CURRENT";
    ServiceType["WATER_QUALITY_SERVICE"] = "WATER_QUALITY_SERVICE";
    ServiceType["WATER_QUALITY_FILTER"] = "WATER_QUALITY_FILTER";
    ServiceType["HUMIDITY_SERVICE"] = "HUMIDITY_SERVICE";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
var ServiceRequestStatus;
(function (ServiceRequestStatus) {
    ServiceRequestStatus["OPEN"] = "open";
    ServiceRequestStatus["PENDING"] = "pending";
    ServiceRequestStatus["IN_PROGRESS"] = "in_progress";
    ServiceRequestStatus["RESCHEDULE"] = "reschedule";
    ServiceRequestStatus["CANCELED"] = "canceled";
    ServiceRequestStatus["CLOSED"] = "closed";
})(ServiceRequestStatus = exports.ServiceRequestStatus || (exports.ServiceRequestStatus = {}));
